import React from 'react';

/**
 * Placeholder de carregamento que imita a forma do conteúdo real (cards e
 * linhas de texto) em vez de um spinner cobrindo a tela inteira. A Sidebar
 * e o Header continuam visíveis e normais enquanto os dados carregam — só
 * a área de conteúdo mostra os blocos "pulsando".
 */
const Bloco: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 dark:bg-gray-700 rounded ${className}`} />
);

const SkeletonLoader: React.FC = () => {
  return (
    <div className="space-y-6">
      <Bloco className="h-8 w-48" />

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-4">
        <Bloco className="h-5 w-40" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Bloco className="h-24" />
          <Bloco className="h-24" />
          <Bloco className="h-24" />
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-3">
        <Bloco className="h-5 w-32" />
        <Bloco className="h-4 w-full" />
        <Bloco className="h-4 w-5/6" />
        <Bloco className="h-4 w-4/6" />
      </div>
    </div>
  );
};

export default SkeletonLoader;
